import {useMatchMedia} from '@pexip/hooks';

import {LG} from '../../constants/mediaQueries';

export const useLg = () => useMatchMedia(LG);
